<template>
  <div class="page">
    <header class="site-header">
      <div class="container header-inner">
        <div class="brand">
          <img class="brand-logo" src="/logo.png" alt="Bergier Assurances" />
          <div class="brand-text">
            <p class="brand-name">Bergier Assurances</p>
            <p class="brand-tagline">Courtier indépendant en assurances</p>
          </div>
        </div>
        <nav class="site-nav">
          <router-link to="/">Accueil</router-link>
          <router-link to="/entreprises">Entreprises</router-link>
          <router-link to="/particuliers">Particuliers</router-link>
          <router-link to="/fine-art">Fine Art</router-link>
          <router-link to="/contact">Contact</router-link>
        </nav>
        <router-link class="cta" to="/contact">Demander un conseil</router-link>
      </div>
    </header>

    <main>
      <router-view />
    </main>

    <footer class="site-footer">
      <div class="container footer-inner">
        <div>
          <p class="brand-name">Bergier Assurances</p>
          <p>Conseil indépendant et accompagnement durable.</p>
        </div>
        <div class="footer-links">
          <router-link to="/">Accueil</router-link>
          <router-link to="/entreprises">Entreprises</router-link>
          <router-link to="/particuliers">Particuliers</router-link>
          <router-link to="/fine-art">Fine Art</router-link>
          <router-link to="/contact">Contact</router-link>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'App'
};
</script>

<style>
:root {
  color-scheme: light;
  --bg: #f5f7fb;
  --text: #1a2232;
  --muted: #5c677c;
  --primary: #1f4b99;
  --primary-dark: #163972;
  --accent: #e8eefb;
  --card: #ffffff;
  --border: #e2e7f1;
  --shadow: 0 20px 60px rgba(16, 24, 40, 0.08);
  font-family: "Inter", "Segoe UI", system-ui, -apple-system, sans-serif;
}

* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

body {
  background: var(--bg);
  color: var(--text);
}

a {
  color: inherit;
  text-decoration: none;
}

.page {
  min-height: 100vh;
}

.container {
  width: min(1120px, 92vw);
  margin: 0 auto;
}

.site-header {
  position: sticky;
  top: 0;
  background: rgba(245, 247, 251, 0.95);
  backdrop-filter: blur(12px);
  border-bottom: 1px solid var(--border);
  z-index: 10;
}

.header-inner {
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: center;
  gap: 24px;
  padding: 18px 0;
}

.brand {
  display: flex;
  align-items: center;
  gap: 14px;
}

.brand-logo {
  width: 68px;
  height: 68px;
  object-fit: contain;
}

.brand-name {
  font-size: 1rem;
  font-weight: 600;
}

.brand-tagline {
  color: var(--muted);
  font-size: 0.85rem;
}

.site-nav {
  display: flex;
  justify-content: center;
  gap: 18px;
  color: var(--muted);
  font-size: 0.95rem;
}

.site-nav a:hover {
  color: var(--primary);
}

.site-nav .router-link-active {
  color: var(--primary);
  font-weight: 600;
}

.cta {
  padding: 10px 18px;
  border-radius: 999px;
  border: 1px solid var(--primary);
  color: var(--primary);
  font-weight: 500;
}

.hero {
  padding: 72px 0 80px;
  background: linear-gradient(140deg, rgba(247, 249, 255, 0.96) 0%, rgba(238, 243, 255, 0.94) 40%, rgba(255, 255, 255, 0.98) 100%);
}

.hero-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 40px;
  align-items: center;
}

.eyebrow {
  text-transform: uppercase;
  letter-spacing: 0.18em;
  color: var(--primary);
  font-size: 0.75rem;
  font-weight: 600;
  margin-bottom: 14px;
}

.hero-content h1 {
  font-size: clamp(2.1rem, 3vw, 3.2rem);
  line-height: 1.15;
  margin-bottom: 18px;
}

.lead {
  font-size: 1.05rem;
  line-height: 1.6;
  color: var(--muted);
  margin-bottom: 26px;
}

.hero-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
  margin-bottom: 32px;
}

.button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 12px 22px;
  border-radius: 12px;
  font-weight: 600;
  border: 1px solid transparent;
}

.button.primary {
  background: var(--primary);
  color: #fff;
  box-shadow: var(--shadow);
}

.button.ghost {
  border-color: var(--primary);
  color: var(--primary);
  background: #fff;
}

.button.full {
  width: 100%;
}

.hero-metrics {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 16px;
}

.metric-value {
  font-size: 1.4rem;
  font-weight: 600;
}

.metric-label {
  color: var(--muted);
  font-size: 0.9rem;
}

.hero-card {
  background: var(--card);
  border-radius: 20px;
  padding: 28px;
  box-shadow: var(--shadow);
  border: 1px solid var(--border);
}

.hero-card h2 {
  font-size: 1.2rem;
  margin-bottom: 18px;
}

.hero-card ul {
  list-style: none;
  display: grid;
  gap: 10px;
  color: var(--muted);
  margin-bottom: 20px;
}

.hero-card-footer {
  border-top: 1px solid var(--border);
  padding-top: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  color: var(--primary);
  font-weight: 500;
}

.section {
  padding: 72px 0;
}

.section.alt {
  background: #ffffff;
}

.section-header {
  max-width: 620px;
  margin-bottom: 36px;
}

.section-header h2 {
  font-size: 2rem;
  margin-bottom: 12px;
}

.section-header p {
  color: var(--muted);
  line-height: 1.6;
}

.grid {
  display: grid;
  gap: 22px;
}

.grid.three {
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
}

.grid.four {
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
}

.card {
  background: var(--card);
  padding: 24px;
  border-radius: 18px;
  border: 1px solid var(--border);
  box-shadow: 0 12px 40px rgba(16, 24, 40, 0.06);
}

.card h3 {
  margin-bottom: 10px;
}

.card p {
  color: var(--muted);
  line-height: 1.6;
  margin-bottom: 16px;
}

.pill {
  display: inline-flex;
  padding: 6px 12px;
  border-radius: 999px;
  background: var(--accent);
  color: var(--primary);
  font-size: 0.85rem;
  font-weight: 500;
}

.icon {
  width: 44px;
  height: 44px;
  display: grid;
  place-items: center;
  background: var(--accent);
  color: var(--primary);
  border-radius: 12px;
  margin-bottom: 14px;
}

.icon svg {
  width: 24px;
  height: 24px;
}

.text-link {
  color: var(--primary);
  font-weight: 500;
}

.method-grid {
  display: grid;
  gap: 40px;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  align-items: center;
}

.steps {
  display: grid;
  gap: 18px;
}

.step {
  display: grid;
  grid-template-columns: 40px 1fr;
  gap: 14px;
  align-items: start;
  background: var(--card);
  border-radius: 16px;
  padding: 18px;
  border: 1px solid var(--border);
}

.step span {
  display: grid;
  place-items: center;
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: var(--primary);
  color: #fff;
  font-weight: 600;
}

.step h3 {
  margin-bottom: 6px;
}

.step p {
  color: var(--muted);
}

.split {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 32px;
  align-items: start;
}

.list {
  list-style: none;
  display: grid;
  gap: 10px;
  margin-top: 18px;
  color: var(--muted);
}

.list li::before {
  content: "•";
  color: var(--primary);
  margin-right: 10px;
}

.panel {
  background: var(--card);
  border-radius: 18px;
  padding: 24px;
  border: 1px solid var(--border);
  box-shadow: 0 12px 40px rgba(16, 24, 40, 0.06);
  display: grid;
  gap: 12px;
}

.stat {
  padding: 22px;
  background: var(--card);
  border-radius: 16px;
  border: 1px solid var(--border);
}

.stat h3 {
  margin-bottom: 8px;
}

.stat p {
  color: var(--muted);
}

.contact {
  background: linear-gradient(120deg, #f2f5ff 0%, #ffffff 60%);
}

.contact-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 32px;
  align-items: start;
}

.contact-details {
  display: grid;
  gap: 16px;
  margin-top: 24px;
}

.label {
  font-weight: 600;
  margin-bottom: 6px;
}

.contact-card {
  background: var(--card);
  border-radius: 18px;
  padding: 24px;
  box-shadow: var(--shadow);
  border: 1px solid var(--border);
  display: grid;
  gap: 16px;
}

.contact-card label {
  display: grid;
  gap: 6px;
  font-size: 0.9rem;
  color: var(--muted);
}

.contact-card input,
.contact-card textarea {
  border: 1px solid var(--border);
  border-radius: 10px;
  padding: 10px 12px;
  font-size: 0.95rem;
  font-family: inherit;
}

.privacy {
  color: var(--muted);
  font-size: 0.8rem;
}

.site-footer {
  padding: 32px 0 40px;
  border-top: 1px solid var(--border);
  background: #fff;
}

.footer-inner {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 20px;
  color: var(--muted);
}

.footer-links {
  display: flex;
  gap: 16px;
}

@media (max-width: 860px) {
  .header-inner {
    grid-template-columns: 1fr;
    justify-items: start;
  }

  .site-nav {
    justify-content: flex-start;
    flex-wrap: wrap;
  }

  .cta {
    justify-self: start;
  }
}

@media (max-width: 600px) {
  .hero-actions {
    flex-direction: column;
  }

  .hero-card-footer {
    flex-direction: column;
    align-items: flex-start;
  }
}
</style>